@if (hasData) {
  <div class="checkbox-container">
    <label>
      <input type="checkbox" [(ngModel)]="showSpeedLines" (change)="updateCharts()" />
      Show speed lines (7200 and 8400 rpm) in graphs
    </label>
  </div>
  <div class="scaling-ui">
    <h5 class="scaling-heading">Graph Scaling</h5>
    <div class="scaling-row">
      <!-- Flow Axis -->
      <div class="scaling-section">
        <div class="scaling-content">
          <label class="checkbox">
            <input type="checkbox" [(ngModel)]="autoScaleFlow" (change)="updateCharts()" />
            Auto Scale Flow Axes
          </label>
          @if (!autoScaleFlow) {
            <div class="manual-entry-wrapper">
              <label class="section-title">Flow Axes Limits [m³/s]</label>
              <div class="input-group">
                <div class="input-block">
                  <label>Min</label>
                  <input type="number" [(ngModel)]="flowMin" (input)="updateCharts()" />
                </div>
                <div class="input-block">
                  <label>Max</label>
                  <input type="number" [(ngModel)]="flowMax" (input)="updateCharts()" />
                </div>
                <div class="input-block">
                  <label>Step</label>
                  <input type="number" [(ngModel)]="flowStep" (input)="updateCharts()" />
                </div>
              </div>
            </div>
          }
        </div>
      </div>
      <!-- Vacuum Axis -->
      <div class="scaling-section">
        <div class="scaling-content">
          <label class="checkbox">
            <input type="checkbox" [(ngModel)]="autoScaleVacuum" (change)="updateCharts()" />
            Auto Scale Vacuum Axis
          </label>
          @if (!autoScaleVacuum) {
            <div class="manual-entry-wrapper">
              <label class="section-title">Vacuum Axis Limits [kPa]</label>
              <div class="input-group">
                <div class="input-block">
                  <label>Min</label>
                  <input type="number" [(ngModel)]="vacuumMin" (input)="updateCharts()" />
                </div>
                <div class="input-block">
                  <label>Max</label>
                  <input type="number" [(ngModel)]="vacuumMax" (input)="updateCharts()" />
                </div>
                <div class="input-block">
                  <label>Step</label>
                  <input type="number" [(ngModel)]="vacuumStep" (input)="updateCharts()" />
                </div>
              </div>
            </div>
          }
        </div>
      </div>
      <!-- Power Axis -->
      <div class="scaling-section">
        <div class="scaling-content">
          <label class="checkbox">
            <input type="checkbox" [(ngModel)]="autoScalePower" (change)="updateCharts()" />
            Auto Scale Power Axis
          </label>
          @if (!autoScalePower) {
            <div class="manual-entry-wrapper">
              <label class="section-title">Power Axis Limits [kW]</label>
              <div class="input-group">
                <div class="input-block">
                  <label>Min</label>
                  <input type="number" [(ngModel)]="powerMin" (input)="updateCharts()" />
                </div>
                <div class="input-block">
                  <label>Max</label>
                  <input type="number" [(ngModel)]="powerMax" (input)="updateCharts()" />
                </div>
                <div class="input-block">
                  <label>Step</label>
                  <input type="number" [(ngModel)]="powerStep" (input)="updateCharts()" />
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="card-container">
    @for (chart of charts; track chart) {
      @if (chart.id !== 'chart6' || showEfficiencyChart) {
        <div class="chart-card">
          <button
            type="button"
            class="chart-expand-btn"
            (click)="openChartFullscreen(chart)"
            aria-label="Expand chart"
            title="Expand chart">
            <img src="assets/icons/chart-expand.png" alt="" width="18" height="18" />
          </button>
          <div class="chart-title">{{ chart.title }}</div>
          <div [id]="chart.id" class="chart"></div>
        </div>
      }
    }
  </div>
} @else {
  <div class="no-data-message p-4 text-center">
    <p class="mb-0">Please enter the inputs and click on the Submit button in the Results tab before viewing graphs.</p>
  </div>
}
